import { Sponsor } from '../../types/event.types';
import sortBy from 'lodash/sortBy';
import uniq from 'lodash/uniq';
import { isSameDay, isSameYear } from 'date-fns';

const parseSponsorsForState = (sponsors: Sponsor[]): Sponsor[] | Array<Sponsor[]> => {
  const orderedByPosition = sortBy(sponsors, 'position');

  if (sponsors.every((sponsor) => sponsor.position !== null && sponsor.partnership_type)) {
    const types = uniq(orderedByPosition.map((sponsor: Sponsor) => sponsor.partnership_type));

    return types.map((type: string) => {
      return orderedByPosition.filter((sponsor: Sponsor) => sponsor.partnership_type === type);
    });
  }

  return orderedByPosition;
};

const parseEventForState = (event) => ({
  ...event,
  singleDayWithTimespan:
    event?.ends_at && isSameDay(new Date(event?.starts_at), new Date(event?.ends_at)),
  multiDayEvent: event?.ends_at && !isSameDay(new Date(event?.starts_at), new Date(event?.ends_at)),
  multiYearEvent:
    event?.ends_at && !isSameYear(new Date(event?.starts_at), new Date(event?.ends_at)),
});

export { parseSponsorsForState, parseEventForState };
